import router from '@/router'
import Cookie from 'vue-cookies'
// import store from '@/store'

// const writePath = ['login', 'first', 'error', 'error1', 'userAgreement', 'aboutUs', 'topUpAgreement', 'driverAgreement', 'download', 'download1', 'downloadPage', 'downloadPc', 'invitation', 'driverShare', 'insuranceAgreement', 'driverDownLoad']
// const writePathWx = ['topUpAgreement', 'error1', 'userAgreement', 'driverAgreement', 'aboutUs', 'download', 'download1', 'downloadPage', 'downloadPc', 'invitation', 'driverShare', 'insuranceAgreement', 'driverDownLoad']

function isWeiXin () {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  let ua = window.navigator.userAgent.toLowerCase()
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log(to.name)
  // alert(to.name)
  // console.log(writePath.indexOf(to.name) === -1)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (!isWeiXin()) {
    if (to.meta.noWx && to.meta.noWx === true) {
      next()
    } else {
      if (to.name === 'error1') {
        next()
      } else {
        router.push({
          path: '/401'
        })
      }
    }
  } else {
    if (to.name === 'error1') {
      router.push({
        name: 'first'
      })
    } else {
      // if (writePath.indexOf(to.name) === -1) {
      if (!to.meta.noLogin) {
        if (Cookie.get('my-token') === null || Cookie.get('my-token') === '') {
          if (Cookie.get('openid') && Cookie.get('openid') !== '') {
            router.push({
              path: '/login',
              query: {
                openid: Cookie.get('openid')
              }
            })
          } else {
            console.log(1)
            router.push({
              path: '/login'
            })
          }
        } else {
          next()
        }
      } else if (to.name === 'login' || to.name === 'first') {
        if (Cookie.get('my-token') && Cookie.get('my-token') !== '') {
          router.push({
            path: '/orderQuery'
          })
        } else {
          next()
        }
        // next()
      } else {
        next()
      }
    }
    next()
  }
})



// WEBPACK FOOTER //
// ./src/api/routerChange.js